<template>
  <div class="report-orders">
    <el-card shadow="never" class="orders-card">
      <el-table :data="orders" style="width: 100%;" border stripe v-loading="loading">
        <el-table-column prop="orderNo" label="订单号" width="200" />
        <el-table-column prop="product" label="商品" min-width="180" />
        <el-table-column prop="branch" label="所属分身" width="150">
          <template slot-scope="scope">
            <span class="branch-name">{{ scope.row.branch }}</span>
          </template>
        </el-table-column>
        <el-table-column label="金额" width="120">
          <template slot-scope="scope">
            <span class="price-bold">¥{{ scope.row.amount }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="发货状态" width="120">
          <template slot-scope="scope">
            <span class="gray-text">{{ scope.row.status }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleDetail(scope.row)">详情</el-button>
            <el-button type="text" size="small" style="color: #e6a23c;" @click="handleFlag(scope.row)">标记异常</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-wrap">
        <span>共 {{ total }} 条记录</span>
        <el-pagination background layout="prev, pager, next" :total="total" :page-size="limit" :current-page.sync="page" @current-change="fetchOrders" />
      </div>
    </el-card>
  </div>
</template>

<script>
import { getReportOrders, markOrderAbnormal } from '@/api'

export default {
  name: 'ReportOrders',
  data() {
    return {
      orders: [],
      total: 0,
      page: 1,
      limit: 10,
      loading: false
    }
  },
  mounted() {
    this.fetchOrders()
  },
  methods: {
    fetchOrders() {
      this.loading = true
      getReportOrders({ page: this.page, limit: this.limit }).then(res => {
        this.orders = res.list || []
        this.total = res.total || 0
      }).catch(() => {
        this.$message.error('获取报单订单失败')
      }).finally(() => {
        this.loading = false
      })
    },
    handleDetail(row) { this.$message.info(`查看详情: ${row.orderNo}`) },
    handleFlag(row) {
      this.$confirm(`确认标记异常: ${row.orderNo}？`, '标记异常', { type: 'warning' }).then(() => {
        markOrderAbnormal({ orderNo: row.orderNo }).then(() => {
          this.$message.success('已标记异常')
          this.fetchOrders()
        }).catch(() => {
          this.$message.error('标记异常失败')
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.orders-card { border-radius: 8px; }
.price-bold { font-weight: bold; }
.branch-name { color: #409EFF; }
.gray-text { color: #909399; }
.pagination-wrap { display: flex; align-items: center; justify-content: space-between; padding: 16px 0 0; font-size: 13px; color: #909399; }
</style>
